const urlPattern = /^(https?:\/\/)?(localhost|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63})(:\d{2,5})?(\/[^\s]*)?(\?.*)?$/
const isURL = (url: string) => urlPattern.test(url)

export default isURL
